export const isNotAuthenticated = ({ code }) => code === 'NOT_AUTHENTICATED'

export const isPublicOperation = operationName => /login/i.test(operationName) || /register/i.test(operationName) || /RecoveryPassword/.test(operationName) || /NewPassword/i.test(operationName)
